import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { GlassCard } from "@/components/lux";
import { Quote, Globe } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/public/testimonials").then((r) => setItems(r.data.testimonials || [])).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section id="voices" className="relative mx-auto max-w-7xl px-5 py-20">
      <p className="mb-3 text-xs font-bold uppercase tracking-[0.25em] text-[var(--gold-2)]">Global Voices</p>
      <h2 className="font-display text-3xl font-extrabold text-[var(--royal)] sm:text-4xl">Trusted by builders across the world</h2>
      <p className="mt-3 max-w-2xl text-sm text-[var(--text-dim)]">Members from different countries share their experience with our platform.</p>
      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
        {items.map((t, i) => (
          <GlassCard key={i} hover className="flex flex-col p-6" data-testid={`testimonial-${i}`}>
            <Quote size={22} className="text-[var(--gold-2)]" />
            <p className="mt-3 flex-1 text-sm text-[var(--text-dim)]">"{t.message}"</p>
            <div className="mt-5 flex items-center gap-3 border-t border-[var(--line)] pt-4">
              <div className="grid h-10 w-10 place-items-center rounded-full text-lg" style={{ background: "rgba(18,60,140,0.08)", border: "1px solid rgba(18,60,140,0.15)" }}>
                {t.flag || <Globe size={16} className="text-[var(--royal)]" />}
              </div>
              <div className="leading-tight">
                <p className="text-sm font-bold text-[var(--royal)]">{t.name}</p>
                <p className="text-xs text-[var(--text-dim)]">{t.country} · <span className="font-semibold text-[var(--gold-2)]">{t.rank}</span></p>
              </div>
            </div>
          </GlassCard>
        ))}
      </div>
    </section>
  );
}
